/**
 * Checks if the current date is within the 14-day withdrawal period.
 * @param startDate - ISO string of subscription start date
 * @returns true if within 14 days of the start date
 */
export const isWithinWithdrawalPeriod = (
  startDate: string | null
): boolean => {
  if (!startDate) return false;

  const start = new Date(startDate);
  const now = new Date();
  const daysElapsed = (now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);

  return daysElapsed <= 14;
};

/**
 * Calculates the withdrawal deadline (14 days after start date).
 * @param startDate - ISO string of subscription start date
 * @returns Date object of the deadline, or null if no start date
 */
export const getWithdrawalDeadline = (
  startDate: string | null
): Date | null => {
  if (!startDate) return null;

  const start = new Date(startDate);
  const deadline = new Date(start);
  deadline.setDate(deadline.getDate() + 14);

  return deadline;
};

/**
 * Formats the withdrawal deadline for display.
 * @param startDate - ISO string of subscription start date
 * @returns Formatted string like "Aug 15, 2026", or null if no start date
 */
export const formatWithdrawalDeadline = (
  startDate: string | null
): string | null => {
  const deadline = getWithdrawalDeadline(startDate);
  if (!deadline) return null;

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(deadline);
};
